export class UserNotificationSettings {
    constructor(public sendMails: boolean, public interval: string) {}
}